import { SKELETON_KEY } from './skeletonFactory';

export function skeletonHtmlTemplates() {
  return {
    id: SKELETON_KEY,
    name: SKELETON_KEY,
    content: SKELETON_KEY
  };
}
